import { Link } from 'gatsby'
import Logo from 'src/components/ui/Logo'
import { BagCartOutline } from 'src/components/Icons/BagCartOutline'
import { useCartToggleButton } from 'src/sdk/cart/useCartToggleButton'
import { POPUP_APP_INSTALL_EVENT_ID } from 'src/components/PopUps/PopUpAppsflyer/PopUpInstallAppB'
import { useEffect, useState } from 'react'

import { SearchInput } from '../../SearchInput'
import { SidebarMenu } from '../SideBarMenu/SideBarMenu'
import { ButtonIcon } from '../ButtonIcon'
import { MOBILE_MENU_BADGE_DIMENSIONS } from './HeaderMobile'

export const FIXED_ELEMENTS_PLACEHOLDER_ID = 'fixed-elements-placeholder'

type Props = {
  visible: boolean
  onClickLogin: () => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  handleLogoClick: () => void
}
export function HeaderMobileFixed({
  visible,
  onClickLogin,
  isOpen,
  setIsOpen,
  handleLogoClick,
}: Props) {
  const [appModalOpen, setAppModalOpen] = useState(false)

  const cartButtonProps = useCartToggleButton()

  useEffect(() => {
    function handlePopupEvent(e: Event) {
      const event = e as CustomEvent<{ visible: boolean }>

      setAppModalOpen(event?.detail?.visible)
    }

    document.addEventListener(POPUP_APP_INSTALL_EVENT_ID, handlePopupEvent)

    return () => {
      document.removeEventListener(POPUP_APP_INSTALL_EVENT_ID, handlePopupEvent)
    }
  }, [])

  return (
    <div
      className={`fixed top-0 left-0 w-full z-[200] bg-white border-b border-gray transition-all duration-300 restructure-small-desktop:hidden
        ${
          visible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-full pointer-events-none'
        }
        ${appModalOpen ? 'mt-16' : ''}
      `}
    >
      <div className="p-3 flex justify-between items-center">
        <Link
          to="https://www.decathlon.com.br"
          onClick={handleLogoClick}
          aria-label="Ir para a página inicial da Decathlon"
        >
          <Logo width={27} height={23} bgFill="#3643BA" short />
        </Link>

        <SearchInput isOpen={isOpen} setIsOpen={setIsOpen} thinStyle />

        <div className="flex items-center gap-3">
          <SidebarMenu onClickLogin={onClickLogin} showTitle={false} />

          <ButtonIcon
            aria-label="Ir para o carrinho"
            badgeValue={cartButtonProps.itemsTotal}
            badgeDimensions={{ ...MOBILE_MENU_BADGE_DIMENSIONS }}
            {...cartButtonProps}
          >
            <BagCartOutline className="w-6 h-6" />
          </ButtonIcon>
        </div>
      </div>
      <div id={FIXED_ELEMENTS_PLACEHOLDER_ID} />
    </div>
  )
}
